import { useQuery } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import {
	type GoalDetailResponseDTO,
	getGoalIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useGoalDetailQuery = (
	id: number | null,
	options?: { enabled?: boolean },
) => {
	return useQuery({
		queryKey: GoalsKeys.detail(id),
		queryFn: async (context): Promise<GoalDetailResponseDTO | null> => {
			const goal = await processResponse(() => getGoalIdV2(id!))(context);
			return goal ?? null;
		},
		enabled: id !== null && options?.enabled !== false,
	});
};
